// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"0b691726","787":"bfed8136","982":"0c786e73"}[chunkId] + ".chunk.js";
};